import { StoreService } from "@services/store.service";
export const FetchPlugin = {
  /**
   * The priority of the plugin relative to other plugins that determines call
   * order. Higher numbers have higher priority. If not specified it will
   * default to a priority of 0.
   */
  priority: 100,
  preRequest: function (requestArgs: any, ...args: any) {

    // if (requestArgs.method == "upload") {
    //   console.log("FetchPlugin preRequest", requestArgs);
    //   console.log(this);
    //   const newFile = new File([requestArgs.file], requestArgs.file.name.replace(/\s/gmi, "_"), { type: requestArgs.file.type });
    //   requestArgs.fileName = requestArgs.fileName.replace(/\s/gmi, "_");
    //   requestArgs.file = newFile;
    // }

    if (requestArgs.method !== "upload" && requestArgs.method !== "delete") {
      if (!requestArgs.opts?.header) {
        requestArgs.opts.header = {};
        requestArgs.opts.header.map = {};
      }
      // debugger
      requestArgs.opts.header.map["o-auth-key"] = localStorage.getItem("session-Token");
    }
    // crypt('salt', JSON.stringify(test));
    // console.log(crypt('salt', JSON.stringify(test)));


  },
  // staticRequest: function (args: any) {
  //   // console.log(args);
  //   // You can alter the response by changing null to the response you wish to make.
  //   return Promise.resolve(20);
  // },
  /**
   * An initialization function called when registered with Formio.
   *
   * @param Formio - The static class of the Form.io SDK
   */
  init: (Formio: any) => {
    // console.log("FetchPlugin preRequest", Formio);
  },

  wrapStaticRequestPromise: function (promise: Promise<any>, requestArgs: any) {
    return promise
      .then((response: any) => {
        if (requestArgs.url.includes('core-api/tag/list?simple=true&ibks=true')) {
          try {
            const _result = JSON.parse(response);
            _result.result.map((el: any) => {
              if (el.name.includes('Automated_Verified_')) {
                el.name = 'Automated_Verified'
              }
              if (el.name.includes('Chargeback/refund_')) {
                el.name = 'Chargeback/refund'
              }
              if (/^Verified_[A-Za-z]+$/.test(el.name)) {
                el.name = 'Verified'
              }
              return el
            })
            return JSON.stringify(_result);
          } catch (error) {
            return response;
          }
          return response;

        }
        return response;

        // тут можно модифицировать ответ
      })
      .catch((err: { status: number; }) => {
        console.error("❌ error", err);

        // например, глобальная обработка 401
        if (err.status === 401) {
          // redirectToLogin();
        }

        throw err;
      });
  },


  /**
   * A deregistration function called when deregistering with Formio
   *
   * @param Formio - The static class of the Form.io SDK
   */
  deregister: (Formio: any) => {
    // console.log(Formio)
  },

};
// https://crm-dev.gbl-systems.com/api/en/content/media/upload/needforspin/tournament/en?baseUrl=https%3A%2F%2Fcrm-dev.gbl-systems.com%2Fproject&project=&form=

// const crypt = (salt, text) => {
//   const textToChars = (text) => text.split('').map((c) => c.charCodeAt(0));
//   const byteHex = (n) => ('0' + Number(n).toString(16)).substr(-2);
//   const applySaltToChar = (code) =>
//     textToChars(salt).reduce((a, b) => a ^ b, code);

//   return text
//     .split('')
//     .map(textToChars)
//     .map(applySaltToChar)
//     .map(byteHex)
//     .join('');
// };
